import { default as _91id_93c9MryHGiyJMeta } from "/app/src/pages/activities/[id].vue?macro=true";
import { default as verifyxfcD1DRdR1Meta } from "/app/src/pages/auth/vk/verify.vue?macro=true";
import { default as _91name_93zh6w2cFVxGMeta } from "/app/src/pages/categories/[name].vue?macro=true";
import { default as events_45by_45datesI23VgeeantMeta } from "/app/src/pages/events-by-dates.vue?macro=true";
import { default as indexhpYbdWauRlMeta } from "/app/src/pages/filter-events/index.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as login3hUYZUGxmUMeta } from "/app/src/pages/login.vue?macro=true";
import { default as _91id_930AsdAVkZXPMeta } from "/app/src/pages/orders/[id].vue?macro=true";
import { default as _91id_93GWSn9UYrHuMeta } from "/app/src/pages/organizations/[id].vue?macro=true";
import { default as privacy3wcvBua6OkMeta } from "/app/src/pages/privacy.vue?macro=true";
import { default as search5UN5dWklNeMeta } from "/app/src/pages/search.vue?macro=true";
import { default as ticket_45refundazlFpa8biAMeta } from "/app/src/pages/ticket-refund.vue?macro=true";
import { default as edit_45profile9pd2C0LJk4Meta } from "/app/src/pages/user/edit-profile.vue?macro=true";
import { default as favouritesoBUdl8RKq3Meta } from "/app/src/pages/user/favourites.vue?macro=true";
import { default as indexAXkeIboLlqMeta } from "/app/src/pages/user/index.vue?macro=true";
import { default as _91id_93Z2JIui2XcUMeta } from "/app/src/pages/user/orders/[id].vue?macro=true";
import { default as indexySMBgLruGXMeta } from "/app/src/pages/user/orders/index.vue?macro=true";
export default [
  {
    name: _91id_93c9MryHGiyJMeta?.name ?? "activities-id",
    path: _91id_93c9MryHGiyJMeta?.path ?? "/activities/:id()",
    meta: _91id_93c9MryHGiyJMeta || {},
    alias: _91id_93c9MryHGiyJMeta?.alias || [],
    redirect: _91id_93c9MryHGiyJMeta?.redirect,
    component: () => import("/app/src/pages/activities/[id].vue").then(m => m.default || m)
  },
  {
    name: verifyxfcD1DRdR1Meta?.name ?? "auth-vk-verify",
    path: verifyxfcD1DRdR1Meta?.path ?? "/auth/vk/verify",
    meta: verifyxfcD1DRdR1Meta || {},
    alias: verifyxfcD1DRdR1Meta?.alias || [],
    redirect: verifyxfcD1DRdR1Meta?.redirect,
    component: () => import("/app/src/pages/auth/vk/verify.vue").then(m => m.default || m)
  },
  {
    name: _91name_93zh6w2cFVxGMeta?.name ?? "categories-name",
    path: _91name_93zh6w2cFVxGMeta?.path ?? "/categories/:name()",
    meta: _91name_93zh6w2cFVxGMeta || {},
    alias: _91name_93zh6w2cFVxGMeta?.alias || [],
    redirect: _91name_93zh6w2cFVxGMeta?.redirect,
    component: () => import("/app/src/pages/categories/[name].vue").then(m => m.default || m)
  },
  {
    name: events_45by_45datesI23VgeeantMeta?.name ?? "events-by-dates",
    path: events_45by_45datesI23VgeeantMeta?.path ?? "/events-by-dates",
    meta: events_45by_45datesI23VgeeantMeta || {},
    alias: events_45by_45datesI23VgeeantMeta?.alias || [],
    redirect: events_45by_45datesI23VgeeantMeta?.redirect,
    component: () => import("/app/src/pages/events-by-dates.vue").then(m => m.default || m)
  },
  {
    name: indexhpYbdWauRlMeta?.name ?? "filter-events",
    path: indexhpYbdWauRlMeta?.path ?? "/filter-events",
    meta: indexhpYbdWauRlMeta || {},
    alias: indexhpYbdWauRlMeta?.alias || [],
    redirect: indexhpYbdWauRlMeta?.redirect,
    component: () => import("/app/src/pages/filter-events/index.vue").then(m => m.default || m)
  },
  {
    name: indexdPwi6hPdMfMeta?.name ?? "index",
    path: indexdPwi6hPdMfMeta?.path ?? "/",
    meta: indexdPwi6hPdMfMeta || {},
    alias: indexdPwi6hPdMfMeta?.alias || [],
    redirect: indexdPwi6hPdMfMeta?.redirect,
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: login3hUYZUGxmUMeta?.name ?? "login",
    path: login3hUYZUGxmUMeta?.path ?? "/login",
    meta: login3hUYZUGxmUMeta || {},
    alias: login3hUYZUGxmUMeta?.alias || [],
    redirect: login3hUYZUGxmUMeta?.redirect,
    component: () => import("/app/src/pages/login.vue").then(m => m.default || m)
  },
  {
    name: _91id_930AsdAVkZXPMeta?.name ?? "orders-id",
    path: _91id_930AsdAVkZXPMeta?.path ?? "/orders/:id()",
    meta: _91id_930AsdAVkZXPMeta || {},
    alias: _91id_930AsdAVkZXPMeta?.alias || [],
    redirect: _91id_930AsdAVkZXPMeta?.redirect,
    component: () => import("/app/src/pages/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93GWSn9UYrHuMeta?.name ?? "organizations-id",
    path: _91id_93GWSn9UYrHuMeta?.path ?? "/organizations/:id()",
    meta: _91id_93GWSn9UYrHuMeta || {},
    alias: _91id_93GWSn9UYrHuMeta?.alias || [],
    redirect: _91id_93GWSn9UYrHuMeta?.redirect,
    component: () => import("/app/src/pages/organizations/[id].vue").then(m => m.default || m)
  },
  {
    name: privacy3wcvBua6OkMeta?.name ?? "privacy",
    path: privacy3wcvBua6OkMeta?.path ?? "/privacy",
    meta: privacy3wcvBua6OkMeta || {},
    alias: privacy3wcvBua6OkMeta?.alias || [],
    redirect: privacy3wcvBua6OkMeta?.redirect,
    component: () => import("/app/src/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: search5UN5dWklNeMeta?.name ?? "search",
    path: search5UN5dWklNeMeta?.path ?? "/search",
    meta: search5UN5dWklNeMeta || {},
    alias: search5UN5dWklNeMeta?.alias || [],
    redirect: search5UN5dWklNeMeta?.redirect,
    component: () => import("/app/src/pages/search.vue").then(m => m.default || m)
  },
  {
    name: ticket_45refundazlFpa8biAMeta?.name ?? "ticket-refund",
    path: ticket_45refundazlFpa8biAMeta?.path ?? "/ticket-refund",
    meta: ticket_45refundazlFpa8biAMeta || {},
    alias: ticket_45refundazlFpa8biAMeta?.alias || [],
    redirect: ticket_45refundazlFpa8biAMeta?.redirect,
    component: () => import("/app/src/pages/ticket-refund.vue").then(m => m.default || m)
  },
  {
    name: edit_45profile9pd2C0LJk4Meta?.name ?? "user-edit-profile",
    path: edit_45profile9pd2C0LJk4Meta?.path ?? "/user/edit-profile",
    meta: edit_45profile9pd2C0LJk4Meta || {},
    alias: edit_45profile9pd2C0LJk4Meta?.alias || [],
    redirect: edit_45profile9pd2C0LJk4Meta?.redirect,
    component: () => import("/app/src/pages/user/edit-profile.vue").then(m => m.default || m)
  },
  {
    name: favouritesoBUdl8RKq3Meta?.name ?? "user-favourites",
    path: favouritesoBUdl8RKq3Meta?.path ?? "/user/favourites",
    meta: favouritesoBUdl8RKq3Meta || {},
    alias: favouritesoBUdl8RKq3Meta?.alias || [],
    redirect: favouritesoBUdl8RKq3Meta?.redirect,
    component: () => import("/app/src/pages/user/favourites.vue").then(m => m.default || m)
  },
  {
    name: indexAXkeIboLlqMeta?.name ?? "user",
    path: indexAXkeIboLlqMeta?.path ?? "/user",
    meta: indexAXkeIboLlqMeta || {},
    alias: indexAXkeIboLlqMeta?.alias || [],
    redirect: indexAXkeIboLlqMeta?.redirect,
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Z2JIui2XcUMeta?.name ?? "user-orders-id",
    path: _91id_93Z2JIui2XcUMeta?.path ?? "/user/orders/:id()",
    meta: _91id_93Z2JIui2XcUMeta || {},
    alias: _91id_93Z2JIui2XcUMeta?.alias || [],
    redirect: _91id_93Z2JIui2XcUMeta?.redirect,
    component: () => import("/app/src/pages/user/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: indexySMBgLruGXMeta?.name ?? "user-orders",
    path: indexySMBgLruGXMeta?.path ?? "/user/orders",
    meta: indexySMBgLruGXMeta || {},
    alias: indexySMBgLruGXMeta?.alias || [],
    redirect: indexySMBgLruGXMeta?.redirect,
    component: () => import("/app/src/pages/user/orders/index.vue").then(m => m.default || m)
  }
]